module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-manage"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-bar"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("关键字:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "20px"
    },
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchCourses.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchKeyword),
      callback: function($$v) {
        _vm.searchKeyword = $$v
      },
      expression: "searchKeyword"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("分类:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px",
      "margin-right": "20px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部分类",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  })], 2), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchCourses
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-bar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCourse
    }
  }, [_vm._v("添加课程")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.courseList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "课程分类",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程图片",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "80px",
            "height": "60px",
            "object-fit": "cover"
          },
          attrs: {
            "src": scope.row.pictureUrl || '/static/img/default-course.jpg',
            "alt": "课程图片"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "课程名称",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.courseType === 1 ? 'success' : 'warning'
          }
        }, [_vm._v("\n          " + _vm._s(scope.row.courseType === 1 ? '免费' : 'VIP') + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.status === 1 ? 'success' : 'danger'
          }
        }, [_vm._v("\n          " + _vm._s(scope.row.status === 1 ? '上架中' : '已下架') + "\n        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editCourse(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status === 1 ? 'warning' : 'success'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(scope.row)
            }
          }
        }, [_vm._v("\n          " + _vm._s(scope.row.status === 1 ? '下架' : '上架') + "\n        ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCourse(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isEdit ? '编辑课程' : '添加课程',
      "visible": _vm.showAddDialog,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAddDialog = $event
      },
      "close": _vm.resetForm
    }
  }, [_c('el-form', {
    ref: "courseForm",
    attrs: {
      "model": _vm.courseForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入课程名称"
    },
    model: {
      value: (_vm.courseForm.name),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "name", $$v)
      },
      expression: "courseForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.courseForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "categoryId", $$v)
      },
      expression: "courseForm.categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教练",
      "prop": "instructor"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入教练姓名"
    },
    model: {
      value: (_vm.courseForm.instructor),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "instructor", $$v)
      },
      expression: "courseForm.instructor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程时长",
      "prop": "duration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 300,
      "placeholder": "分钟"
    },
    model: {
      value: (_vm.courseForm.duration),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "duration", $$v)
      },
      expression: "courseForm.duration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "难度等级",
      "prop": "difficulty"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择难度"
    },
    model: {
      value: (_vm.courseForm.difficulty),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "difficulty", $$v)
      },
      expression: "courseForm.difficulty"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "初级",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "中级",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "高级",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入课程描述"
    },
    model: {
      value: (_vm.courseForm.description),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "description", $$v)
      },
      expression: "courseForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.courseForm.status),
      callback: function($$v) {
        _vm.$set(_vm.courseForm, "status", $$v)
      },
      expression: "courseForm.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAddDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveCourse
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("课程管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29223f8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/course/courseManage.vue
// module id = 975
// module chunks = 0